import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getMappedBusinessReviewData } from "containers/creditReview/details/tabs/executiveSummary/sections/businessReview/getMappedBusinessReviewData";
import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { BusinessReviewDto, ErrorResponse } from "types";

type useGetBusinessReviewByCreditReviewIdQueryProps = {
	creditReviewId: string;
};

const useGetBusinessReviewByCreditReviewIdQuery = ({
	creditReviewId,
}: useGetBusinessReviewByCreditReviewIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["creditReviewBusinessMessage", creditReviewId],
		() =>
			creditReviewDetailsService.getBusinessReview({
				creditReviewId,
			}),
		{
			select: (data: BusinessReviewDto) => {
				return getMappedBusinessReviewData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetBusinessReviewByCreditReviewIdQuery;
